define(function(require) {
	return {
		EMAIL:'email',
		SMS:'sms',
		VERIFICATION:'verification',
		AUTHENTICATION:'authentication',
		NOTIFIED:'notified',
		INVALIDCODE:'invalidcode',
		INVALIDCODELASTATTEMPT:'invalidcodelastattempt',
		ATTEMPTEXCEEDED:'attemptexceeded',
		NOSECURITYCODE:'nosecuritycode',
		GENERALERROR:'nosecuritycode',//nosecuritycode is actually the response for any unknown error from the RS
		//deferred states
		RESOLVED:'resolved',
		PENDING:'pending',
		REJECTED:'rejected',
		//backbone http methods
		DESTROY:'destroy',
		SAVE:'save'
	}
});